module.exports = __webpack_public_path__ + "assets/icons/door-closed.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/svg/door-closed.svg
// module id = lRq9
// module chunks = 1